import classNames from 'classnames'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { requestGeoentityVde } from '../../dataSource/geoentity/geoentity.requests'
import { closeVde } from '../../store/ad/ad.actions'
import { selectBboxForVde, selectPageIdForAdConfig, selectVdeName } from '../../store/ad/ad.selectors'
import { TAG_VDE_CLOSE, TAG_VDE_CTA } from '../analytics/analytics.tagids.constants'
import { selectHasUserConsentedForNativeAdvertising } from '../../store/cmp/cmp.selectors'
import { selectIsMapInitialized } from '../../store/map/map.selectors'
import { selectIsFrenchSite, selectLocale } from '../../store/navigation/navigation.selectors'
import { isGE } from '../Device'
import { SPD_PUSH_DISPLAY } from '../analytics/BiTagger'
import TagActionButton from '../genericComponents/TagActionButton'
import cross from '../genericComponents/assets/cross.svg'
import RectangleActionButton, {
  COLOR_GREEN_EMPTY,
  SIZE_SMALL
} from '../genericComponents/buttons/RectangleActionButton'
import SVGIcon from '../svg/SVGIcon'
import { convertBboxToWestSouthEastNorthBbox } from '../utils/map'
import { useAction, withEverySelectorTruthy } from '../utils/react-redux'
import useEventCallback from '../utils/useEventCallback'
import { getAdIdByAdName } from './AdConfigService'
import AdLoader from './AdLoader'
import s from './VdeBanner.less'
import { useAdData } from './ad.utils'
import { useClickVde, useSendVdeBucTag, useShouldDisplayVde, useVdeLinkAndTags } from './ad.vde.utils'

export const VdeBannerContent = ({ adName }) => {
  const pageId = useSelector(selectPageIdForAdConfig)
  const adId = getAdIdByAdName(adName, pageId)
  const data = useAdData(adId)
  const { tagVdeType, app, subcategory, rubric } = useVdeLinkAndTags(adId)
  const [isDisplayTagSent, setDisplayTagSent] = useState(false)
  const onClick = useClickVde(adId)
  const shouldDisplayVde = useShouldDisplayVde(adId)
  const sendVdeBucTag = useSendVdeBucTag(adId)
  const execCloseVde = useAction(closeVde)

  useEffect(() => () => execCloseVde(), [])

  const closeVDE = useEventCallback(execCloseVde, [execCloseVde])

  if (!shouldDisplayVde) return <></>

  const {
    vde: { title, description, buttonLabel, imgUrl }
  } = data

  const isOnMap = isGE()
  const tagInfo = {
    tagVdeType,
    appId: app,
    catId: subcategory || rubric
  }

  if (!isDisplayTagSent) {
    setDisplayTagSent(true)
    sendVdeBucTag(SPD_PUSH_DISPLAY)
  }

  return (
    <div className={classNames(s.root, isOnMap ? s.onMap : '')}>
      <TagActionButton type={TAG_VDE_CTA} tagInfo={tagInfo} className={s.linkWrapper} deferClick onClick={onClick}>
        <div className={s.content}>
          <div className={s.title}>{title}</div>
          <div className={s.description}> {description}</div>
          <div className={s.center}>
            <RectangleActionButton
              className={s.button}
              color={COLOR_GREEN_EMPTY}
              size={SIZE_SMALL}
              label={buttonLabel}
            />
          </div>
        </div>
        {imgUrl && (
          <div className={s.imageContainer}>
            <img className={s.img} src={imgUrl} />
          </div>
        )}
      </TagActionButton>
      {isOnMap && (
        <TagActionButton
          type={TAG_VDE_CLOSE}
          tagInfo={tagInfo}
          className={s.onMapCloseButton}
          deferClick
          onClick={closeVDE}
        >
          <SVGIcon url={cross} />
        </TagActionButton>
      )}
    </div>
  )
}

export const VdeBanner = withEverySelectorTruthy(
  selectIsFrenchSite,
  selectIsMapInitialized,
  selectBboxForVde
)(() => {
  const adName = useSelector(selectVdeName)
  const hasUserConsent = useSelector(selectHasUserConsentedForNativeAdvertising)
  const bbox = useSelector(selectBboxForVde)
  const [selectorObj, setSelectorObj] = useState(null)
  const selector = useCallback(() => selectorObj, [selectorObj])
  const locale = useSelector(selectLocale)

  useEffect(() => {
    const formattedBbox = convertBboxToWestSouthEastNorthBbox(bbox)
    requestGeoentityVde(formattedBbox, locale).then(({ appIds }) => {
      setSelectorObj({ vde: appIds.join(',') })
    })
  }, [])

  if (!adName || !hasUserConsent || !selectorObj) return <></>

  return (
    <div id={adName}>
      <AdLoader adName={adName} keywordsSelector={selector} askData={true}>
        <VdeBannerContent adName={adName} />
      </AdLoader>
    </div>
  )
})
